import React, { useEffect, useState } from "react";
import {
	Container,
	Box,
	Typography,
	Card,
	CardContent,
	Divider,
	useTheme,
	Button as MUIButton,
} from "@mui/material";
import NavbarCustomer from "../../components/NavbarCustomer";
import ResponsiveAppBar from "../../components/ResponsiveAppBar";
import axios from "axios";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import CustomInput from "../../components/shared/CustomInput";
import Button from "../../components/shared/Button";
import { Apple, Facebook, Google } from "../../svgs";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { base_URL } from "../../config/config";
import {
	closeModals,
	toggleResetWorkMail,
	toggleSignUp,
	toggleSocial,
} from "../../store/features/modalSlice";
import { useDispatch } from "react-redux";
import { setUser } from "../../store/features/authSlice";
import { useNavigate } from "react-router-dom";
import backgroundIcon from "../../assets/images/background_icon.svg";
import User from "../../assets/img/user.png";
import OutlinedLabelledTextField from "../../components/OutlinedLabelledTextfield";

export default function UserLogin() {
	const customer = JSON.parse(localStorage.getItem("authUser")) || null;
	const customerId = customer?._id || null;
	return (
		<div className="flex flex-col h-screen">
			{customerId ? (
				<div className="z-[999]">
					<NavbarCustomer />
				</div>
			) : (
				<div className="z-[9999]">
					<ResponsiveAppBar />
				</div>
			)}
			<LoginModal />
		</div>
	);
}

const LoginModal = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState({
		email: "",
		password: "",
		success: "",
	});
	const dispatch = useDispatch();

	const onSignUpClick = () => navigate("/user-signup");
	const onSocialClick = () => dispatch(toggleSocial());

	const validation = () => {
		if (!email) {
			setError((prev) => ({
				...prev,
				email: "Please enter your email address.",
			}));
		}
		if (!password) {
			setError((prev) => ({
				...prev,
				password: "Please enter your password.",
			}));
		}
	};
	const handleLogin = async () => {
		validation();
		if (error.email !== "" || error.password !== "") {
			return;
		}

		setIsLoading(true);

		try {
			const response = await axios.post(`${base_URL}/api/auth/login`, {
				email,
				password,
			});

			// Assuming the token comes in response.data.token
			const { token, user } = response.data;
			// console.log(user);

			// Handle successful login (store token, redirect, etc.)
			if (user.isVerified) {
				toast.success("Logged in successfully!");
				dispatch(closeModals());

				dispatch(setUser(user)); // Save user to Redux
				localStorage.setItem("authToken", token); // Store token in localStorage
				localStorage.setItem("authUser", JSON.stringify(user)); // Store user in localStorage      setIsLoading(false);
				navigate("/");
			} else {
				setIsLoading(false);
				toast.error("Please verify your email to login.");
			}

			// Redirect or do additional steps after login if needed
		} catch (error) {
			setIsLoading(false);
			setError((prev) => ({
				...prev,
				success: "Login failed. Please check your credentials and try again.",
			})); // Clear previous errors
		}
	};

	const handleForgotPassword = async () => {
		dispatch(toggleResetWorkMail());
	};

	//  Facebook login handler
	const handleFacebookResponse = async (response) => {
		try {
			if (response.accessToken) {
				const result = await axios.get(
					`${base_URL}/api/auth/facebook?access_token=${response.accessToken}`
				);
				const { data, token } = result.data;

				dispatch(setUser(data));
				dispatch(closeModals());

				localStorage.setItem("authToken", token);
				localStorage.setItem("authUser", JSON.stringify(data));

				toast.success("Logged in successfully!");
				navigate("/");
			}
		} catch (error) {
			console.error("Facebook login error:", error);
			toast.error(
				error.response?.data?.message || "Failed to login with Facebook"
			);
		}
	};
	useEffect(() => {
		// Initialize Facebook SDK
		window.fbAsyncInit = function () {
			window.FB.init({
				appId: process.env.REACT_APP_FACEBOOK_APP_ID,
				cookie: true,
				xfbml: true,
				version: "v17.0",
			});
		};

		// Load Facebook SDK
		(function (d, s, id) {
			var js,
				fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) return;
			js = d.createElement(s);
			js.id = id;
			js.src = "https://connect.facebook.net/en_US/sdk.js";
			fjs.parentNode.insertBefore(js, fjs);
		})(document, "script", "facebook-jssdk");
	}, []);

	const isFormValid = () => {
		return email.trim() !== "" && password.trim() !== "";
	};

	return (
		<div
			style={{
				backgroundImage: `url(${backgroundIcon})`,
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				backgroundPosition: "right",
				minHeight: "75vh",
			}}
		>
			<Container>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column",
					}}
				>
					<Typography
						variant="h4"
						gutterBottom
						sx={{
							mt: { xs: 5, md: 10 },
							fontWeight: "bold",
							fontSize: { xs: "1.8rem" },
						}}
					>
						<div className="flex items-center space-x-4">
							<img src={User} alt="user" className="h-10" />
							<span>User login</span>
						</div>
						{/* Log in as{" "} */}
						{/* <span style={{ color: theme.palette.primary.main }}>Customer</span> */}
					</Typography>
				</Box>
			</Container>

			<Container
				maxWidth="sm"
				sx={{ display: "flex", justifyContent: "center" }}
			>
				<Box
					sx={{
						mt: 6,
						width: { xs: "95%", md: "80%" },
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						gap: 1,
					}}
				>
					<OutlinedLabelledTextField
						label={"Email address"}
						type={"text"}
						placeholder={"Enter your email address"}
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						error={error.email}
					/>
					<OutlinedLabelledTextField
						label={"Password"}
						type={"password"}
						placeholder={"Enter your password"}
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						error={error.password}
					/>

					<Box sx={{ mb: 2, textAlign: "right" }}>
						<Link
							onClick={handleForgotPassword}
							color="primary"
							sx={{
								textDecoration: "none",
								fontWeight: "500",
								cursor: "pointer",
							}}
						>
							Forgot Password?
						</Link>
					</Box>

					{error.success && (
						<Typography color="error" variant="body2">
							{error.success}
						</Typography>
					)}

					<MUIButton
						onClick={handleLogin}
						label={isLoading ? "Logging in..." : "Log in"}
						disabled={isLoading || !isFormValid()}
						type="submit"
						variant="contained"
						fullWidth
						size="large"
						sx={{
							mb: { xs: 1, md: 3 },
							borderRadius: "8px",
							mt: 2,
							backgroundColor: isFormValid() ? "primary.main" : "grey.border",
							color: isFormValid() ? "white" : "text",
						}}
					>
						{isLoading ? "Logging in..." : "Log in"}
					</MUIButton>

					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							gap: 2,
							mt: 3,
						}}
					>
						<FacebookLogin
							appId={process.env.REACT_APP_FACEBOOK_APP_ID}
							autoLoad={false}
							fields="name,email,picture"
							callback={handleFacebookResponse}
							render={(renderProps) => (
								<Box
									className="border border-dark rounded-md px-4 py-2 cursor-pointer"
									onClick={renderProps.onClick}
									sx={{
										display: "flex",
										justifyContent: "center",
										width: "100%",
										height: "100%",
										alignItems: "center",
									}}
								>
									<Facebook />
								</Box>
							)}
						/>

						<Box
							className="border border-dark rounded-md px-4 py-2"
							sx={{
								display: "flex",
								justifyContent: "center",
								width: "100%",
								alignItems: "center",
							}}
						>
							<Apple />
						</Box>

						<Box
							onClick={onSocialClick}
							className="border border-dark rounded-md px-4 py-2 cursor-pointer"
							sx={{
								display: "flex",
								justifyContent: "center",
								width: "100%",
								alignItems: "center",
							}}
						>
							<Google />
						</Box>
					</Box>

					<Divider sx={{ my: 1 }} />

					<Typography
						variant="body1"
						gutterBottom
						sx={{ textAlign: "center", color: "grey.text" }}
					>
						Don’t have a User Account?{" "}
						<span
							onClick={onSignUpClick}
							className="underline cursor-pointer font-medium"
							style={{ color: theme.palette.primary.main }}
						>
							Sign up
						</span>
					</Typography>
				</Box>
			</Container>
		</div>
	);
};
